import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {Construct} from 'classes/construct';
import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {ConstructsOverviewService} from './services/constructs-overview.service';

@Component({
  selector: 'constructs-overview',
  templateUrl: './constructs-overview.component.html',
  styleUrls: ['./constructs-overview.component.css'],
})
export class ConstructsOverviewComponent implements OnInit {

  private constructs: Array<Construct> = [];
  private constructsFullLoaded: boolean = false;
  public filteredConstructs: Array<Construct> = [];
  public distributionStatus: 'all' | 'distributed' | 'notDistributed' = 'all';
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private overviewService: ConstructsOverviewService,
              private router: Router) { }

  public ngOnInit(): void {
    this.overviewService.getAllConstructs(true)
      .subscribe((constructs: Array<Construct>) => {
        this.constructs = constructs;
        this.filteredConstructs = constructs;
        this.prepareFieldsToSearch();
      });
  }

  private onEditButton(constructId: number): void { // tslint:disable-line
    this.router.navigate(['constructs', 'details', {constructId: constructId}]);
  }

  public onCloneButton(constructId: number): void {
    this.router.navigate(['constructs', 'details', {constructId: constructId, clone: true}]);
  }

  public onCreateButton(): void { // tslint:disable-line
    this.router.navigate(['constructs', 'details']);
  }

  public deleteConstruct(id: number): void { // tslint:disable-line
    this.overviewService.deleteDialog(id)
      .subscribe((result) => {
        const index: number = this.constructs.findIndex((element) => {
          return element._id === id;
        });

        if (index > -1) {
          this.constructs.splice(index, 1);
        }
      });
  }

  public filterConstructs(eventConstructs: Array<Construct>): void {
    this.filteredConstructs = eventConstructs;
  }

  public showDeleteModal(constructId: number): void { // tslint:disable-line
    const constructName: string = this.getConstructById(constructId).name;
    const content: string = `Sind Sie sicher, dass Sie das Konstrukt "${constructName}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(constructId)
      .show();
  }

  public getDistributedIcon(construct: Construct) { // tslint:disable-line
    if (construct.isDistributed === undefined) {
      for (let i = 0; i < this.constructs.length; i++) {
        if (this.constructs[i]._id == construct._id) {
          this.constructs[i].isDistributed = null;
          break;
        }
      }
      return this.overviewService.getConstructById(construct._id)
        .subscribe((constructFull: Construct) => {
          construct.isDistributed = constructFull.isDistributed;
          for (let i = 0; i < this.constructs.length; i++) {
            if (this.constructs[i]._id == construct._id) {
              this.constructs[i].isDistributed = constructFull.isDistributed;
              break;
            }
          }
          return construct.isDistributed ? 'glyphicon-ok' : 'glyphicon-remove';
        });
    } else if (construct.isDistributed === null) {
      return 'glyphicon-question-sign';
    } else {
      return construct.isDistributed ? 'glyphicon-ok' : 'glyphicon-remove';
    }
  }

  public getDistributedClass(construct: Construct): string { // tslint:disable-line
    if (construct.isDistributed === undefined) {
      return 'no-button';
    } else if (construct.isDistributed === null) {
      return 'no-button'
    } else {
      return construct.isDistributed ? 'no-button-success' : 'no-button-danger';
    }
  }

  private getConstructById(id: number): Construct {
    return this.constructs.find((construct) => {
      return construct._id === id;
    });
  }

  private hasActiveDialogs(construct: Construct): boolean { // tslint:disable-line
    for (const dialog of construct.dialogs) {
      if (dialog.active) {
        return true;
      }
    }

    return false;
  }

  public get filteredConstructsByDistStatus(): Array<Construct> {
    return this.constructs.filter((construct) => {
      return this.filterByDistributionStatus(construct);
    });
  }

  public prepareFieldsToSearch(): void {
    if (this.distributionStatus != 'all' && !this.constructsFullLoaded) {
      this.constructs = [];
      this.filteredConstructs = this.constructs;
      this.constructsFullLoaded = true;
      this.overviewService.getAllConstructs(false)
        .subscribe((constructs: Array<Construct>) => {
          this.constructs = constructs;
          this.filteredConstructs = constructs;
          this.prepareFieldsToSearch();
        });
        return;
    }

    this.fieldsToSearch = [];
    this.filteredConstructsByDistStatus.forEach((construct) => {
      this.fieldsToSearch.push([
        construct.name.toLowerCase(),
        construct.description.toLowerCase(),
      ]);
    });
  }

  private filterByDistributionStatus(construct: Construct): boolean {
    if (this.distributionStatus === 'all') {
      return true;
    }

    const distributed: boolean = this.distributionStatus === 'distributed';
    return construct.isDistributed === distributed;
  }
};



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-overview/constructs-overview.component.ts